import get from 'lodash/get';

export default function buildStagedIntegrationsMap(stagedIntegrations) {
  return stagedIntegrations.reduce((stagedIntegrationsMap, pipelineIntegration) => {
    const { id: integrationId } = pipelineIntegration.integration;
    const { revision } = pipelineIntegration;

    const { id: revisionId } = revision;
    const { revision: revisionNumber } = revision.playbook;
    const stagedForDelete = revision.stagedForDelete;
    const pipelineVars = getActivePipelineVars({
      allPipelineVariables: revision.pipelineVars,
      activePipelineVariables: revision.playbook.pipelineVars,
    });

    const consentCategoryCode = get(pipelineIntegration, 'consent.category.code', null);
    const consentMode = get(pipelineIntegration, 'consent.mode', null);

    const stagedIntegration = {
      revisionId,
      revisionNumber,
      stagedForDelete,
      pipelineVars,
      consentCategoryCode,
      consentMode,
      disabled: pipelineIntegration.disabled,
    };

    return { ...stagedIntegrationsMap, [integrationId]: stagedIntegration };
  }, {});
}

function getActivePipelineVars({ allPipelineVariables, activePipelineVariables }) {
  const activePipelineVariablesSet = new Set(activePipelineVariables.map(variable => variable.name));

  return Object.entries(allPipelineVariables).reduce(
    (finalPipelineVariables, [pipelineVariableName, pipelineVariableValue]) => {
      const variableIsActive = activePipelineVariablesSet.has(pipelineVariableName);

      if (variableIsActive) {
        return { ...finalPipelineVariables, [pipelineVariableName]: pipelineVariableValue };
      }

      return finalPipelineVariables;
    },
    {}
  );
}
